import { UserNotificationUtilService, UserNotification } from "@scisys-uim/uim-common";

export class ToDoListNotificationUtilService implements UserNotificationUtilService {

  unableToDismissReason(notification?: UserNotification): string {
    return "Cannot dismiss Todo List notifications"
  }

  canBeDismissed(notification: UserNotification): boolean {
    return true;
  }

  getUserMessageType(): string {
    return "ToDoEntry";
  }

  getRouteFromLinkData(notification: UserNotification): any[] {
    return ['/home'];
  }

  getRouteLinkQueryParams(notification: UserNotification) {
    return {};
  }

}
